import { api } from './client';
import {
    DeviceAuthApproveResponse,
    DeviceAuthPollResponse,
    DeviceAuthStartResponse,
} from '../types/responses/device-auth.responses';

export const deviceAuthService = {
    async start(): Promise<DeviceAuthStartResponse['data']> {
        const response = await api.post<DeviceAuthStartResponse>('/device-auth/start');
        return response.data.data;
    },

    async poll(deviceCode: string): Promise<DeviceAuthPollResponse['data']> {
        const response = await api.post<DeviceAuthPollResponse>('/device-auth/poll', {
            device_code: deviceCode,
        });
        return response.data.data;
    },

    async approve(userCode: string): Promise<void> {
        await api.post<DeviceAuthApproveResponse>('/device-auth/approve', {
            user_code: userCode,
        });
    },
};
